const REDIRECTION_CODE = /^3\d{2}$/
const CLIENT_ERROR_CODE = /^4\d{2}$/
const SERVER_ERROR_CODE = /^5\d{2}$/


const COMMON_ERRORS = {
  404: 'No encontramos lo que busca',
  405: 'Lo sentimos, esta acción no está permitida',
}


export const getErrorConfig = errorCode => {
  if (COMMON_ERRORS[errorCode]) {
    return {
      message: COMMON_ERRORS[errorCode]
    }
  }

  if (CLIENT_ERROR_CODE.test(errorCode)) {
    return {
      showErrorsFromResponse: true,
      message: 'Surgieron varios errores en su petición:'
    }
  }

  if (SERVER_ERROR_CODE.test(errorCode)) {
    return {
      message: 'Tuvimos un problema con nuestro servidor.'
    }
  }

  return {}
}